"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FONT_SIZE_INCREMENT_PX = exports.MAX_FONT_SIZE_PX = exports.MIN_FONT_SIZE_PX = exports.DEFAULT_FONT_SIZE_PX = exports.lightMode = exports.lightTheme = exports.darkMode = exports.darkHighlightStyle = exports.darkTheme = void 0;
var view_1 = require("@codemirror/view");
var color_1 = __importDefault(require("@cdo/apps/util/color"));
var language_1 = require("@codemirror/language");
var highlight_1 = require("@lezer/highlight");
// modified from @codemirror/theme-one-dark
var chalky = '#e5c07b', coral = '#e06c75', cyan = '#56b6c2', invalid = '#ffffff', stone = '#7d8799', malibu = '#61afef', sage = '#98c379', whiskey = '#d19a66', violet = '#c678dd', darkBackground = '#21252b', highlightBackground = '#2c313a', selection = '#3E4451', cursor = '#528bff';
/**
The editor theme styles for dark mode.
*/
exports.darkTheme = view_1.EditorView.theme({
    '&': {
        color: color_1.default.lighter_gray,
        backgroundColor: color_1.default.darkest_slate_gray,
    },
    '.cm-content': {
        caretColor: cursor,
    },
    '&.cm-focused .cm-cursor': { borderLeftColor: cursor },
    '&.cm-focused .cm-selectionBackground, .cm-selectionBackground, ::selection': {
        backgroundColor: selection,
    },
    '.cm-panels': { backgroundColor: darkBackground, color: color_1.default.lighter_gray },
    '.cm-panels button': { color: color_1.default.lightest_gray },
    '.cm-panels.cm-panels-top': { borderBottom: '2px solid black' },
    '.cm-panels.cm-panels-bottom': { borderTop: '2px solid black' },
    '.cm-searchMatch': {
        backgroundColor: '#72a1ff59',
        outline: '1px solid #457dff',
    },
    '.cm-searchMatch.cm-searchMatch-selected': {
        backgroundColor: '#6199ff2f',
    },
    '.cm-activeLine': { backgroundColor: color_1.default.dark_gray },
    '.cm-selectionMatch': { backgroundColor: '#aafe661a' },
    '.cm-matchingBracket, .cm-nonmatchingBracket': {
        backgroundColor: '#bad0f847',
        outline: '1px solid #515a6b',
    },
    '.cm-gutters': {
        backgroundColor: color_1.default.darkest_slate_gray,
        color: stone,
        border: 'none',
    },
    '.cm-activeLineGutter': {
        backgroundColor: highlightBackground,
    },
    '.cm-foldPlaceholder': {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#ddd',
    },
    '.cm-tooltip': {
        border: '1px solid #181a1f',
        backgroundColor: darkBackground,
    },
    '.cm-tooltip-autocomplete': {
        '& > ul > li[aria-selected]': {
            backgroundColor: highlightBackground,
            color: color_1.default.lighter_gray,
        },
    },
    '.cm-textfield': { color: color_1.default.lightest_gray },
}, { dark: true });
/**
The highlighting style for code in the dark theme.
*/
exports.darkHighlightStyle = language_1.HighlightStyle.define([
    { tag: highlight_1.tags.keyword, color: violet },
    {
        tag: [
            highlight_1.tags.name,
            highlight_1.tags.deleted,
            highlight_1.tags.character,
            highlight_1.tags.propertyName,
            highlight_1.tags.macroName,
            highlight_1.tags.definition(highlight_1.tags.name),
        ],
        color: coral,
    },
    {
        tag: [highlight_1.tags.function(highlight_1.tags.variableName), highlight_1.tags.labelName],
        color: malibu,
    },
    {
        tag: [highlight_1.tags.color, highlight_1.tags.constant(highlight_1.tags.name), highlight_1.tags.standard(highlight_1.tags.name)],
        color: whiskey,
    },
    {
        tag: [highlight_1.tags.separator],
        color: color_1.default.lighter_gray,
    },
    {
        tag: [
            highlight_1.tags.typeName,
            highlight_1.tags.className,
            highlight_1.tags.number,
            highlight_1.tags.changed,
            highlight_1.tags.annotation,
            highlight_1.tags.modifier,
            highlight_1.tags.self,
            highlight_1.tags.namespace,
        ],
        color: chalky,
    },
    {
        tag: [
            highlight_1.tags.operator,
            highlight_1.tags.operatorKeyword,
            highlight_1.tags.url,
            highlight_1.tags.escape,
            highlight_1.tags.regexp,
            highlight_1.tags.link,
            highlight_1.tags.special(highlight_1.tags.string),
        ],
        color: cyan,
    },
    { tag: [highlight_1.tags.meta, highlight_1.tags.comment], color: stone },
    { tag: highlight_1.tags.strong, fontWeight: 'bold' },
    { tag: highlight_1.tags.emphasis, fontStyle: 'italic' },
    { tag: highlight_1.tags.strikethrough, textDecoration: 'line-through' },
    { tag: highlight_1.tags.link, color: stone, textDecoration: 'underline' },
    { tag: highlight_1.tags.heading, fontWeight: 'bold', color: coral },
    {
        tag: [highlight_1.tags.atom, highlight_1.tags.bool, highlight_1.tags.special(highlight_1.tags.variableName)],
        color: whiskey,
    },
    { tag: [highlight_1.tags.processingInstruction, highlight_1.tags.string, highlight_1.tags.inserted], color: sage },
    { tag: highlight_1.tags.invalid, color: invalid },
]);
/**
Extension to enable the dark theme (both the editor theme and
the highlight style).
*/
exports.darkMode = [exports.darkTheme, (0, language_1.syntaxHighlighting)(exports.darkHighlightStyle)];
// The default light theme styles for codemirror
exports.lightTheme = view_1.EditorView.theme({
    // Sets the background color for the main editor area
    '&': {
        backgroundColor: color_1.default.white,
    },
    // Sets the background color for the left-hand side gutters
    '.cm-gutters': {
        backgroundColor: color_1.default.white,
    },
}, { dark: false });
// Extension to enable the light theme (both the editor theme and the highlight style).
exports.lightMode = [
    exports.lightTheme,
    (0, language_1.syntaxHighlighting)(language_1.defaultHighlightStyle),
];
exports.DEFAULT_FONT_SIZE_PX = 13;
exports.MIN_FONT_SIZE_PX = 13;
exports.MAX_FONT_SIZE_PX = 68;
exports.FONT_SIZE_INCREMENT_PX = 5;
